import { useIntl } from 'react-intl';

import { Button, FocusRingVariants } from '@calm-web/design-system';

import Image from '@/components/image/NextImage';
import { useAnalytics } from '@/hooks/analytics';
import { useLocale } from '@/hooks/locale/useLocale';

import { classRoomImage, classRoomUrl, selfCareImage, selfCareUrl } from './data';
import messages from './messages';
import { Column, Copy, Heading, Photo, Wrapper } from './styles';
import { SupportedSchoolLanguage } from './types';

const Classroom = () => {
	const { formatMessage } = useIntl();
	const { calmLanguage } = useLocale();
	const { logEvent } = useAnalytics();

	const onCtaClick = (copy: string, href: string) => {
		logEvent({
			eventName: 'Schools : Resources : CTA : Clicked',
			eventProps: {
				copy,
				href,
				type: 'button',
			},
		});
		window.open(href);
	};

	return (
		<Wrapper>
			<Column>
				<Photo>
					<Image
						src={classRoomImage[calmLanguage as SupportedSchoolLanguage] || classRoomImage.en}
						alt="Boy listening to music lying on grass"
						fill
					/>
				</Photo>
				<Heading>{formatMessage(messages.heading1)}</Heading>
				<Copy>{formatMessage(messages.copy1)}</Copy>
				<Button
					onPress={() =>
						onCtaClick(
							messages.heading1.defaultMessage,
							classRoomUrl[calmLanguage as SupportedSchoolLanguage] || classRoomUrl.en,
						)
					}
					backgroundColor="schoolBlue"
					focusRingVariant={FocusRingVariants.Dark}
				>
					{formatMessage(messages.cta)}
				</Button>
			</Column>
			<Column>
				<Photo>
					<Image
						src={selfCareImage[calmLanguage as SupportedSchoolLanguage] || selfCareImage.en}
						alt="Boy listening to music lying on grass"
						fill
						style={{ objectPosition: 'contain' }}
					/>
				</Photo>
				<Heading>{formatMessage(messages.heading2)}</Heading>
				<Copy>{formatMessage(messages.copy2)}</Copy>
				<Button
					focusRingVariant={FocusRingVariants.Dark}
					onPress={() =>
						onCtaClick(
							messages.heading2.defaultMessage,
							selfCareUrl[calmLanguage as SupportedSchoolLanguage] || selfCareImage.en,
						)
					}
					backgroundColor="schoolBlue"
				>
					{formatMessage(messages.cta)}
				</Button>
			</Column>
		</Wrapper>
	);
};

export default Classroom;
